export enum Tax {
    ID = 'id',
    Registrar = 'registrar'
}

export enum CompanyRegistration {
    ID= 'id',
    Registrar= 'registrar'
}

export enum Financial {
    BankName= 'bank_name',
    Bic= 'bic',
    Iban= 'iban',
    Swift= 'swift'
}

export enum AccountingDetails {
    AccountId= 'account_id',
    Ledger= 'ledger',
    TaxTypeId= 'tax_type_id',
    TaxGroupId= 'tax_group_id'
}

export enum InvoiceMeta {
    InvoiceDisclaimer = 'invoice_disclaimer',
    BankAccountId = 'bank_account_id',
    BusinessRegistrationId = 'business_registration_id',
    TaxRegistrationId= 'tax_registration_id'
}
